@let modals = modalService.modals.$ | async;

<!-- display each modals -->
@for (modal of modals; track modal.options.id) {
<bazis-modal [modal]="modal"></bazis-modal>
}
